import "./App.css";
import Banner from "./Components/Banner/Banner";
import Nav from "./Components/Nav/Nav";
import Row from "./Components/Rows/Row";
import requests from "./requests";

function App() {
    return (
        <div className="App">
            <Nav />
            <Banner />
            <Row title="NETFLIX ORIGINALS" fetchUrl={requests.getNetflixOriginals} isLargeRow />
            <Row title="Trending Now" fetchUrl={requests.getTrending} />
            <Row title="Top Rated" fetchUrl={requests.getTopRatedMovies} />
            <Row title="Action Movies" fetchUrl={requests.getActionMovies} />
            <Row title="Comedy Movies" fetchUrl={requests.getComedyMovies} />
            <Row title="Horror Movies" fetchUrl={requests.getHorrorMovies} />
            <Row title="Romance Movies" fetchUrl={requests.getHorrorMovies} />
            <Row title="Documentary Films" fetchUrl={requests.getDocs} />
        </div>
    );
}

export default App;
